import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterLoodgieterPage() {
  return <ClusterPageTemplate clusterName="Loodgieter" sectorName="Bouw & Installatie" sectorSlug="bouw-installatie" heroTitle="Website laten maken voor een loodgieter" heroDescription="Een snelle, conversiegerichte website voor jouw loodgietersbedrijf. Wij zorgen dat klanten met spoed jou direct weten te vinden én te bellen." websiteOnderdelen={[{
    icon: 'PhoneIcon',
    title: 'Spoed contact',
    description: 'Een opvallende bel-knop die direct zichtbaar is op mobiel voor klanten met lekkages of verstoppingen.'
  }, {
    icon: 'WrenchIcon',
    title: 'Dienstenoverzicht',
    description: "Heldere pagina's voor je belangrijkste diensten: lekkages, cv-ketels, riolering en sanitair."
  }, {
    icon: 'MapPinIcon',
    title: 'Werkgebied',
    description: "Duidelijke communicatie over de regio's en plaatsen waar je actief bent voor lokale vindbaarheid."
  }, {
    icon: 'StarIcon',
    title: 'Reviews',
    description: 'Ervaringen van tevreden klanten om direct vertrouwen te wekken bij nieuwe websitebezoekers.'
  }]} functionaliteiten={[{
    icon: 'PhoneIcon',
    title: 'Click-to-call',
    description: 'Geoptimaliseerd voor mobiel: met één druk op de knop hebben klanten met spoed jou aan de lijn.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Vindbaarheid op zoektermen als 'loodgieter met spoed [jouw stad]' of 'lekkage verhelpen'."
  }, {
    icon: 'FileTextIcon',
    title: 'Offerteformulier',
    description: 'Een eenvoudig formulier voor minder urgente klussen, zoals het installeren van nieuw sanitair.'
  }]} siblingClusters={[{
    name: 'Bouwbedrijf',
    slug: 'bouwbedrijf'
  }, {
    name: 'Elektricien',
    slug: 'elektricien'
  }, {
    name: 'Dakdekker',
    slug: 'dakdekker'
  }]} faqs={[{
    q: 'Wat kost een website voor een loodgieter?',
    a: 'Een professionele, lokaal vindbare website voor een loodgieter start vanaf €1.500. Neem contact op voor een exacte prijsopgave.'
  }, {
    q: 'Is de website goed zichtbaar op mobiele telefoons?',
    a: 'Absoluut. Bij loodgieters komt vaak meer dan 70% van de bezoekers via mobiel (mensen met spoed). Onze websites zijn 100% mobile-first ontworpen.'
  }, {
    q: 'Hoe zorg ik dat ik gevonden word bij spoedgevallen?',
    a: "We optimaliseren de website voor lokale zoekopdrachten en zorgen voor een extreem snelle laadtijd, wat cruciaal is voor Google's mobiele ranking."
  }, {
    q: 'Kan ik mijn Google reviews tonen op de site?',
    a: 'Ja, we kunnen een koppeling maken waardoor je nieuwste en beste Google reviews automatisch op je website verschijnen.'
  }]} data-id="element-1077" data-mp="1oubot9we7hwf" />;
}